var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0c.63 0 1.255.12 1.837.353a4.815 4.815 0 0 1 1.557 1.005c.446.43.8.942 1.04 1.504a4.5 4.5 0 0 1 .366 1.774v2.318h.8c.636 0 1.247.245 1.697.68A2.28 2.28 0 0 1 16 9.273v5.409a2.28 2.28 0 0 1-.703 1.639c-.45.435-1.06.679-1.697.679H2.4a2.443 2.443 0 0 1-1.697-.679A2.279 2.279 0 0 1 0 14.681V9.274c0-.615.253-1.205.703-1.64A2.444 2.444 0 0 1 2.4 6.956l.8-.001V4.636c0-1.193.477-2.341 1.331-3.204A4.876 4.876 0 0 1 7.786.005L8 0zm5.6 8.5H2.4a.815.815 0 0 0-.566.226.76.76 0 0 0-.234.547v5.409a.76.76 0 0 0 .234.546c.15.145.354.226.566.226h11.2a.815.815 0 0 0 .566-.226.76.76 0 0 0 .234-.546v-5.41a.76.76 0 0 0-.234-.546.814.814 0 0 0-.566-.226zM8 1.545c-.849 0-1.663.326-2.263.906-.6.58-.937 1.366-.937 2.185v2.318h6.4V4.636c0-.789-.313-1.548-.874-2.122a3.249 3.249 0 0 0-2.144-.964L8 1.545z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.4cbb7ac49338046a94ea3d8b4eb91e35.svg";
export { ForwardRef as ReactComponent };